<template>
  <div class="page-orders">
    <Navigation :title="isUserOrder ? '我的订单' : '团队订单'" />
    <div class="tabs-wrap">
      <md-tab-bar v-model="curOrderState" :items="items" :maxLength="4" :ink-length="30" @change="handleChangeTab" />
    </div>
    <!-- 骨架屏 -->
    <div class="skeleton-list" v-if="showOrderListSkeleton">
      <md-skeleton class="skeleton-item" v-for="item in 5" :key="item" avatar title :row="2" :loading="showOrderListSkeleton"></md-skeleton>
    </div>
    <!-- 订单列表 -->
    <div class="order-list-wrap" v-show="orderListData.total_count > 0">
      <md-scroll-view ref="scrollView" :scrolling-x="false" @refreshing="onPullingDownRefresh" @end-reached="onPullingUp">
        <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
        <div class="order-list">
          <OrderItem :channel="channel" :orderItem="orderItem" v-for="(orderItem, index) in orderListData.data" :key="`${orderItem.orderNo}_${index}`" />
        </div>
        <md-scroll-view-more slot="more" :is-finished="!showOrderListSkeleton && !orderListData.loadMore"></md-scroll-view-more>
      </md-scroll-view>
    </div>
    <md-result-page
      style="margin-top:-2rem;"
      type="empty"
      text="还没有订单~"
      v-show="!showOrderListSkeleton && !orderListData.loadMore && orderListData.total_count === 0"
    ></md-result-page>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import OrderItem from '@/components/orderItem'
import { TabBar, ScrollView, ScrollViewRefresh, ScrollViewMore, ResultPage, Skeleton } from 'mand-mobile'
import { getPageData } from '@/utils/help'
const orderItem = {
  orderState: '失效',
  orderType: '天猫',
  orderNo: '694655938387710460',
  goodsId: 572102388072,
  goodsName: '瑜伽垫初学者女士加厚防滑垫子男士加宽长无味瑜珈健身垫三件套装',
  goodsImg: 'http://img.alicdn.com/bao/uploaded/i1/2013961428/O1CN01Bwajlu1MQ498sGSBb_!!2013961428.jpg',
  payTime: '2019-11-04 09:58:26',
  totalPrice: 13.8,
  sharePrice: 0,
}
export default {
  name: 'orders',
  components: {
    Navigation,
    OrderItem,
    [TabBar.name]: TabBar,
    [Skeleton.name]: Skeleton,
    [ResultPage.name]: ResultPage,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  data() {
    return {
      channel: '',
      isUserOrder: true, // 是否为个人订单
      curOrderState: 0, // 当前订单状态
      items: [
        { name: 0, label: '全部' },
        { name: 12, label: '待结算' },
        { name: 3, label: '已结算' },
        { name: 13, label: '已失效' },
      ],
      showOrderListSkeleton: true,
      orderListData: {
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.channel = this.$route.query.channel || 'tbk'
      this.isUserOrder = parseInt(this.$route.query.type || 1) === 1
      this.curOrderState = parseInt(this.$route.query.state || 0)
      this.fetchOrderList(1)
    },
    /**
     * 下拉刷新
     */
    onPullingDownRefresh() {
      this.fetchOrderList(1, true)
    },
    /**
     * 加载更多
     */
    onPullingUp() {
      if (this.orderListData.loadMore) {
        this.fetchOrderList(this.orderListData.currentPage + 1)
      }
    },
    /**
     * 切换tab时重置列表数据
     */
    resetListData() {
      this.orderListData.currentPage = 1
      this.orderListData.pageSize = 10
      this.orderListData.total_count = 0
      this.orderListData.loadMore = true
      this.orderListData.data = []
      this.resetScroll()
    },
    /**
     * 重置滚动器
     */
    resetScroll() {
      const scrollVM = this.$refs.scrollView
      if (scrollVM) {
        scrollVM.scrollTo(0, 0, false)
      }
    },
    /**
     * 切换tab
     */
    handleChangeTab(item, index, prevIndex) {
      this.curOrderState = item.name
      this.resetListData()
      this.fetchOrderList(1)
    },
    /**
     * 订单列表
     */
    fetchOrderList(currentPage, isPullingDownRefresh) {
      if (currentPage === 1) {
        this.showOrderListSkeleton = true
      }
      let promise = this.isUserOrder
        ? this.$http[this.channel].orderList(this.curOrderState, currentPage)
        : this.$http[this.channel].teamOrderList(this.curOrderState, currentPage)
      promise
        .then(res => {
          this.orderListData = getPageData(currentPage, this.orderListData, res)
          if (isPullingDownRefresh || currentPage === 1) {
            // 下拉刷新
            this.$refs.scrollView.finishRefresh()
            this.$refs.scrollView.finishLoadMore() // 重置加载更多
          }
          if (currentPage > 1) {
            // 加载更多
            this.$refs.scrollView.finishLoadMore()
          }
          this.showOrderListSkeleton = false
          this.$nextTick(() => {
            this.$refs.scrollView.reflowScroller()
          })
        })
        .catch(() => {
          this.showOrderListSkeleton = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-orders {
  position: relative;
  height: 100%;
  background: #fff;
  .tabs-wrap {
    height: 0.7rem;
    box-shadow: 0 0 -20px 0 hsla(0, 6%, 58%, 0.6);
  }
  .skeleton-list {
    background: #fff;
    padding: 0.4rem;
  }
  .order-list-wrap {
    position: absolute;
    top: 1.58rem;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    background-color: #f8f8f8;
    .order-list {
      padding: 0.12rem 0.2rem;
    }
  }
}
</style>
